module.exports = __webpack_public_path__ + "img/aliyun.0d73d780.svg";